const React = require("react");
const createReactClass = require("create-react-class");

const Form = require("../../deploynaut/js/Form.jsx");

const CodeBuilder = createReactClass({
	getInitialState() {
		return {
			selectedBuilder: this.props.model.ActiveBuilder,
			securityID: this.props.model.InitialSecurityID,
		};
	},

	handleSelection(code) {
		this.setState({ selectedBuilder: code });
	},

	render() {
		if (this.props.model.Pinned) {
			// eslint-disable-next-line react/jsx-one-expression-per-line
			return <p className="alert alert-info">This environment is currently set to use <b>{this.props.model.Pinned}</b>. If you would like to change this, contact <a href="https://servicedesk.silverstripe.cloud">Service Desk</a>.</p>;
		}

		if (this.props.model.ReadOnly) {
			const activeBuilderName = this.props.model.AvailableBuilders.find(ab => ab.value === this.props.model.ActiveBuilder).name || 'default';

			// eslint-disable-next-line react/jsx-one-expression-per-line
			return <p className="alert alert-info">This environment is currently set to use the <b>{activeBuilderName}</b> builder. You don&apos;t have permission to change this.</p>;
		}

		return (
			<Form.Form
				model={this.props.model}
				url={this.props.model.UpdateURL}
				securityID={this.state.securityID}
				buttonTitle="Save"
				buttonSubmittingTitle="Saving..."
				buttonClass="btn-sm"
			>
				<Form.OptionSet
					name="builder"
					options={this.props.model.AvailableBuilders}
					value={this.props.model.ActiveBuilder}
				/>
			</Form.Form>
		);
	}
});

module.exports = CodeBuilder;
